var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.893,
    height: 108.094,
    viewBox: "0 0 128.893 108.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_148",
    "data-name": "Groupe 148",
    transform: "translate(1406.713 2296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_131",
    "data-name": "Groupe 131",
    transform: "translate(-1406.713 -2296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_464",
    "data-name": "Trac\\xE9 464",
    d: "M302.2,173.813v14.54h-.383V188.2H173.824v.155h-.383v-14.54a6.32,6.32,0,0,1,6.313-6.313H295.884a6.32,6.32,0,0,1,6.314,6.313Z",
    transform: "translate(-173.305 -167.5)",
    fill: "var(--second-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_465",
    "data-name": "Trac\\xE9 465",
    d: "M295.884,167.5H179.755a6.32,6.32,0,0,0-6.313,6.313v83.032a6.32,6.32,0,0,0,6.313,6.313H295.884a6.32,6.32,0,0,0,6.314-6.313V173.813a6.32,6.32,0,0,0-6.313-6.313Zm5.931,89.345a5.938,5.938,0,0,1-5.931,5.931H179.755a5.938,5.938,0,0,1-5.931-5.931V173.813a5.938,5.938,0,0,1,5.931-5.931H295.884a5.938,5.938,0,0,1,5.931,5.931Z",
    transform: "translate(-173.305 -167.5)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 3.826,
    cy: 3.826,
    r: 3.826,
    transform: "translate(22.329 6.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 3.826,
    cy: 3.826,
    r: 3.826,
    transform: "translate(99.047 6.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_466",
    "data-name": "Trac\\xE9 466",
    d: "M255.638,368.779H232.875a3.641,3.641,0,0,1-3.637-3.637V354.384a3.641,3.641,0,0,1,3.637-3.637h22.762a3.641,3.641,0,0,1,3.637,3.637v10.758a3.641,3.641,0,0,1-3.637,3.637Z",
    transform: "translate(-218.427 -315.688)",
    fill: "var(--second-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_467",
    "data-name": "Trac\\xE9 467",
    d: "M458.036,368.779H435.274a3.641,3.641,0,0,1-3.637-3.637V354.384a3.641,3.641,0,0,1,3.637-3.637h22.762a3.641,3.641,0,0,1,3.637,3.637v10.758a3.641,3.641,0,0,1-3.637,3.637Z",
    transform: "translate(-382.103 -315.688)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_468",
    "data-name": "Trac\\xE9 468",
    d: "M457.57,513.138H434.808a3.752,3.752,0,0,1-3.747-3.747V498.632a3.752,3.752,0,0,1,3.747-3.747H457.57a3.752,3.752,0,0,1,3.747,3.747v10.758A3.752,3.752,0,0,1,457.57,513.138Z",
    transform: "translate(-381.637 -432.251)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_469",
    "data-name": "Trac\\xE9 469",
    d: "M254.782,513.138H232.019a3.752,3.752,0,0,1-3.747-3.747V498.632a3.752,3.752,0,0,1,3.747-3.747h22.762a3.752,3.752,0,0,1,3.747,3.747v10.758A3.752,3.752,0,0,1,254.782,513.138Z",
    transform: "translate(-217.646 -432.251)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_470",
    "data-name": "Trac\\xE9 470",
    d: "M659.969,513.138H637.207a3.752,3.752,0,0,1-3.747-3.747V498.632a3.752,3.752,0,0,1,3.747-3.747h22.762a3.752,3.752,0,0,1,3.747,3.747v10.758A3.752,3.752,0,0,1,659.969,513.138Z",
    transform: "translate(-545.314 -432.251)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_471",
    "data-name": "Trac\\xE9 471",
    d: "M659.969,367.96H637.207a3.752,3.752,0,0,1-3.747-3.747V353.454a3.752,3.752,0,0,1,3.747-3.747h22.762a3.752,3.752,0,0,1,3.747,3.747v10.758A3.752,3.752,0,0,1,659.969,367.96Z",
    transform: "translate(-545.314 -314.847)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 6.172,
    cy: 6.172,
    r: 6.172,
    transform: "translate(19.657 37.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_472",
    "data-name": "Trac\\xE9 472",
    d: "M295.684,390.339a.64.64,0,0,1-.385-.128l-.007-.005-1.451-1.111a.644.644,0,1,1,.784-1.023l.94.72,2.22-2.9a.644.644,0,0,1,.9-.119l-.014.019.014-.018a.645.645,0,0,1,.119.9l-2.612,3.406A.645.645,0,0,1,295.684,390.339Z",
    transform: "translate(-270.466 -343.91)",
    fill: "var(--second-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_474",
    "data-name": "Trac\\xE9 474",
    d: "M694.709,458.673a2.055,2.055,0,0,0-.418-3.124l-3.446-18.4-4.191,1.554,4.7,17.6a2.066,2.066,0,0,0,3.349,2.372Z",
    transform: "translate(-626.554 -385.561)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_475",
    "data-name": "Trac\\xE9 475",
    d: "M535.614,394.6a2.182,2.182,0,0,1,0,.344l8.148,6.271,2.311-.949,1.888,3.3-3.927,2.077a1.659,1.659,0,0,1-1.966-.311l-8.145-8.4a2.176,2.176,0,1,1,1.687-2.335Z",
    transform: "translate(-500.898 -349.562)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_476",
    "data-name": "Trac\\xE9 476",
    d: "M465.4,522.695h-2.345l-1.116-7.134H465.4Z",
    transform: "translate(-411.645 -416.925)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_477",
    "data-name": "Trac\\xE9 477",
    d: "M624.628,719.385h-7.563v-.1a2.944,2.944,0,0,1,2.944-2.944h4.619Z",
    transform: "translate(-570.278 -611.342)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_478",
    "data-name": "Trac\\xE9 478",
    d: "M511.4,522.695h-2.345l-1.116-7.134H511.4Z",
    transform: "translate(-448.845 -416.925)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_479",
    "data-name": "Trac\\xE9 479",
    d: "M670.629,719.385h-7.563v-.1a2.944,2.944,0,0,1,2.944-2.944h4.619Z",
    transform: "translate(-607.478 -611.342)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_480",
    "data-name": "Trac\\xE9 480",
    d: "M626.406,588.567a.859.859,0,0,1-.856-.779l-2.044-27.49.1-.008,14.066-1.156,0,.1,1.118,28.478a.861.861,0,0,1-.86.893h-2.758a.856.856,0,0,1-.851-.73l-3.745-23.005a.1.1,0,0,0-.19.014l-.17,22.714a.862.862,0,0,1-.816.854l-2.948.115Z",
    transform: "translate(-575.486 -484.207)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 4.699,
    cy: 4.699,
    r: 4.699,
    transform: "translate(48.621 31.951)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_481",
    "data-name": "Trac\\xE9 481",
    d: "M624.093,429.176a23.157,23.157,0,0,1-6.078-.831.863.863,0,0,1-.619-.9c.633-9.507.781-16.885-.549-21.99a8.572,8.572,0,0,1,.706-6.287,8.274,8.274,0,0,1,7.335-4.347h0q.215,0,.434.015a8.648,8.648,0,0,1,7.9,9.172L632.308,427a.849.849,0,0,1-.539.774A21.857,21.857,0,0,1,624.093,429.176Z",
    transform: "translate(-569.863 -351.332)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_482",
    "data-name": "Trac\\xE9 482",
    d: "M606.209,419.561l-3.52-4.313a1.1,1.1,0,0,1,.29-1.644l4.768-2.841a3.061,3.061,0,0,1,3.857,4.755l-3.726,4.089a1.1,1.1,0,0,1-1.668-.046Z",
    transform: "translate(-558.452 -363.67)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_483",
    "data-name": "Trac\\xE9 483",
    d: "M669.516,413.029a1.1,1.1,0,0,1-.605-.69l-1.585-5.3a3.061,3.061,0,0,1,5.537-2.612l3.064,4.628a1.1,1.1,0,0,1-.452,1.607l-5.042,2.36A1.1,1.1,0,0,1,669.516,413.029Z",
    transform: "translate(-610.686 -357.678)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_484",
    "data-name": "Trac\\xE9 484",
    d: "M625.84,339.369l-3.483-.8c-.359-.082-.791-.239-.841-.6-.067-.491.639-.833.574-1.324-.063-.476-.706-.537-1.165-.677a1.743,1.743,0,0,1-1.085-2.17,1.6,1.6,0,0,1-2.274.193,2.013,2.013,0,0,1-.381-2.36,2.733,2.733,0,0,1,2.052-1.385,4.327,4.327,0,0,1,2.492.464c.051-.542.728-.762,1.272-.767a5.439,5.439,0,0,1,5.1,3.72,4.975,4.975,0,0,1-1.648,5.772Z",
    transform: "translate(-570.198 -298.864)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_485",
    "data-name": "Trac\\xE9 485",
    d: "M537.812,730.883H464.92a.191.191,0,0,1,0-.383h72.892a.191.191,0,1,1,0,.383Z",
    transform: "translate(-464.729 -622.789)",
    fill: "#3f3d56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisite);
export default __webpack_public_path__ + "static/media/visite.82db45e8.svg";
export { ForwardRef as ReactComponent };